/**
 * Returns array of unique values by given object field
 * @param array
 * @param fieldName
 */
export function uniqueArray<T>(array: T[], fieldName:string){
    return  [...new Map(array.map(item =>
        [item[fieldName], item])).values()];
}